import React from 'react';
import { ThemeProvider } from '@mui/material';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';

import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import { DismissibleIconSnackbarContent } from './DismissibleIconSnackbarContent';
import PusherProvider from 'providers/PusherProvider';
import VerificationRequestProvider from 'providers/VerificationRequestProvider';
import ErrorProvider from 'providers/ErrorProvider';

import { useTheme } from 'hooks/useTheme';
import { Router } from 'router/router';

interface IProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<IProps> = ({ children }) => {
  const theme = useTheme();
  return (
    <ThemeProvider theme={theme}>
       <StylesThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={3}
        Components={{
          error: DismissibleIconSnackbarContent,
        }}
      >
        <ErrorProvider>
          <BrowserRouter>
            <Router />
            <PusherProvider>
              <VerificationRequestProvider>{children}</VerificationRequestProvider>
            </PusherProvider>
          </BrowserRouter>
        </ErrorProvider>
      </SnackbarProvider>
       </StylesThemeProvider>
    </ThemeProvider>
  );
};

export default AppProviders;
